import axios from "axios";
import apisConfig from "../../constants/baseUrl";
import { getCookie, removeCookie, setCookie } from "./AccessCookies";

const api = axios.create({
  baseURL: apisConfig.APIS.api_dev,
  withCredentials: true, // Required for sending cookies (refresh token)
});

// Function to refresh the access token
const refreshAccessToken = async (propsData: any) => {
  try {
    const response = await api.post(
      "/refreshToken",
      { ...propsData },
      {
        withCredentials: true,
      }
    );
    const newAccessTokenData = response.data;

    return newAccessTokenData;
  } catch (error) {
    console.error("Failed to refresh token", error);
    return null;
  }
};
// Function to get the refresh token
const getRefreshToken = async (propsData: any) => {
  try {
    const response = await api.post(
      "/refreshToken",
      { ...propsData },
      {
        withCredentials: true,
      }
    );
    const newAccessTokenData = response.data;

    return newAccessTokenData;
  } catch (error) {
    console.error("Failed to refresh token", error);
    return null;
  }
};

// Axios interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 403) {
      console.log("Access token expired, attempting refresh...");

      try {
        let userData = getCookie("UserData");
        const propsData = {
          userId: userData?.userId,
          isAdmin: userData?.isAdmin,
        };

        const newTokenData = await refreshAccessToken(propsData);
        console.log("newTokenData", newTokenData);

        const updatedUserData = {
          accessToken: newTokenData.accessToken,
          userId:
            newTokenData?.userData.admin_id ??
            newTokenData?.userData?.client_id,
          isAdmin: !!newTokenData?.userData.admin_id,
        };

        setCookie("UserData", JSON.stringify(updatedUserData));

        // Update the failed request's authorization header
        originalRequest.headers[
          "Authorization"
        ] = `Bearer ${newTokenData.accessToken}`;

        return api(originalRequest);
      } catch (err) {
        handelTokenExpiration();
        return null;
      }
    } else if (error.responce?.status == 401) {
      const refreshToken = getCookie("RefreshToken");
      console.log("refreshToken", refreshToken);
      if (!refreshToken) {
        handelTokenExpiration();
        return null;
      }
    }

    return Promise.reject(error);
  }
);
const handelTokenExpiration = () => {
  if (!localStorage.getItem("reloaded")) {
    const isLoginPage =
      window.location.pathname === "/" ||
      window.location.pathname === "/clientLogin";
    const isLoggedIn = sessionStorage.getItem("userId");
    if (
      window.location.pathname !== "/" &&
      window.location.pathname !== "/clientLogin"
    ) {
      sessionStorage.setItem("sessionExpired", "true");
      localStorage.setItem("reloaded", "true");
      window.location.reload();
    }

    if (isLoginPage && !isLoggedIn) {
      sessionStorage.removeItem("SelectedMenuItem");
      sessionStorage.removeItem("userId");
      removeCookie("UserData");
      sessionStorage.removeItem("isAdmin");
      localStorage.removeItem("reloaded");
    }
  }
};
export default api;
